import { applyMiddleware, compose, createStore, Middleware, StoreEnhancer, Store } from 'redux';
import { persistCombineReducers, Persistor, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { createEpicMiddleware } from 'redux-observable';
import * as reduxLogger from 'redux-logger';
import { WindowWithDevTools } from '../models/WindowWithDevTools';
import { isDevelopment } from '../logic/env/env';
import { StoreState, reducers } from '../app/app.reducers';
import { rootEpic } from '../app/app.epics';

const epicMiddleware = createEpicMiddleware();
const middlewares: Middleware[] = [epicMiddleware];
let enhancer: StoreEnhancer;

if (isDevelopment()) {
  const composeEnhancers =
    ((window as unknown) as WindowWithDevTools).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const logger: Middleware = reduxLogger.createLogger({ collapsed: true });
  middlewares.push(logger);
  enhancer = composeEnhancers(applyMiddleware(...middlewares));
} else {
  enhancer = compose(applyMiddleware(...middlewares));
}

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth'],
};

const reducer = persistCombineReducers<StoreState>(persistConfig, {
  ...reducers,
});

export const configureStore = () => {
  const preStore: Store<StoreState> = createStore(reducer, enhancer);
  const prePersistor: Persistor = persistStore(preStore);

  epicMiddleware.run(rootEpic as any);

  return {
    persistor: prePersistor,
    store: preStore,
  };
};

export const { store, persistor } = configureStore();
